import React from 'react';
import { Variables } from '../../hooks/useTranslation';

export const getUnenrollmentReasons = (
  t: (key: string, variables?: Variables) => string,
) => [
  {
    value: '01',
    label: <span>{t('I_PREFER_PAPER_BILLS')}</span>,
  },
  {
    value: '02',
    label: <span>{t('I_WANT_A_REMINDER_OF_MY_DUE_DATE')}</span>,
  },
  {
    value: '03',
    label: <span>{t('I_DONT_CHECK_MY_EMAIL_REGULARLY')}</span>,
  },
  {
    value: '04',
    label: <span>{t('I_RECEIVE_TOO_MANY_EMAILS')}</span>,
  },
  {
    value: '05',
    label: <span>{t('I_NEED_PAPER_COPIES_FOR_MY_RECORDS')}</span>,
  },
  {
    value: '06',
    label: <span>{t('I_HAVE_MULTIPLE_ACCOUNTS_AND_PREFER_PAPER_BILLS')}</span>,
  },
  {
    value: '99',
    label: <span>{t('OTHER_REASON')}</span>,
  },
];
